import type { RandomProvider } from "../types/random-provider";

export function createMathRandomProvider(): RandomProvider {
  return { next: () => Math.random() };
}

export function createSeededProvider(seed: number): RandomProvider {
  let state = seed;
  return {
    next: () => {
      state = (state * 1664525 + 1013904223) & 0xffffffff;
      return (state >>> 0) / 0x100000000;
    },
  };
}

export function createSequenceProvider(
  values: ReadonlyArray<number>,
): RandomProvider {
  let index = 0;
  return {
    next: () => {
      if (index >= values.length) {
        throw new Error("Sequence provider exhausted");
      }
      const value = values[index];
      index += 1;
      return value!;
    },
  };
}
